import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=0bb75e5e&scoped=true"
import script from "./Button.js?vue&type=script&lang=js&external"
export * from "./Button.js?vue&type=script&lang=js&external"
import style0 from "./Button.scss?vue&type=style&index=0&id=0bb75e5e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb75e5e",
  null
  
)

export default component.exports